import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default () => {
    const nodeSelectors = {
        testimonialSlider: '[js-testimonials-slider="slider"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.testimonialSlider)) {
            return
        }
        initTestimonialsSlider()
    }

    function initTestimonialsSlider() {

        const testimonialSwiper = new Swiper(nodeSelectors.testimonialSlider, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 50,
            navigation: {
                nextEl: ".testimonials-section .next-button",
                prevEl: ".testimonials-section .prev-button",
            },
            breakpoints: {
                750: {
                    slidesPerView: 1.2,
                },
                1000: {
                    slidesPerView: 2,
                    spaceBetween: 100
                },
                1100: {
                    slidesPerView: 2,
                    spaceBetween: 150
                }
            }
        });
    }

    return Object.freeze({
        init,
    })
}